import { arraySchema, booleanSchema, numberSchema, objectSchema, stringSchema, unionSchema } from '@/schemas'

export const faqSchema = objectSchema({
  question: stringSchema.min(1).max(255),
  answer: stringSchema.min(1).max(1000),
  tags: arraySchema(stringSchema.max(100)),
  priority: unionSchema([numberSchema.min(0).max(1000), stringSchema.min(1, 'Min value is 0')]),
  is_active: booleanSchema,
})
